































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import {  UpdateBaseShop, QueryShopById } from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VImageUpload } from '@/components/upload'
import { TxLocal } from '@/utils/local/TxLocal'
import pcaData from '@/assets/pca.json'
import Rules from '@/utils/rules'

@Component({
  components: {
    VImageUpload,
  },
})
export default class EditBaseShopDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.data = {
      province: undefined,
      city: undefined,
      district: undefined,
      bankCard: { bankType: 1 }
    }
    this.show = false
  }
  private data: any = {
    province: undefined,
    city: undefined,
    district: undefined,
    bankCard: { bankType: 1 }
  }
  private show = false
  private buttonLoading = false
  private isEdit = false
  private pca = pcaData
  // 银行列表
  private bankList: any[] = []

  // 获取省数据
  private get provinceList() {
    return this.pca
  }
  // 获取市数据
  private get cityList() {
    if (!this.data.province) {
      return []
    }
    const t = this.pca.filter((e: any) => e.name == this.data.province)
    if (t.length <= 0) {
      return []
    }
    return t[0].children
  }
  // 获取区数据
  private get districtList() {
    if (!this.data.province || !this.data.city) {
      return []
    }
    const t = this.pca.filter((e: any) => e.name == this.data.province)
    if (t.length <= 0) {
      return []
    }
    const t2 = t[0].children.filter((e: any) => e.name == this.data.city)
    if (t2.length == 0) {
      return []
    }
    return t2[0].children
  }

  private provinceChange() {
    console.log("dsadsa")
    this.data.city = undefined;
    this.data.district = undefined;
  }

  private bankChange() {
    const res = this.bankList.filter(e => e.bankCode == this.data.bankCard.bankCode)
    if (res.length > 0) {
      this.data.bankCard.bankName = res[0].bankName
    } else {
      this.data.bankCard.bankName = ""
    }
  }



  public async open(data: any, isEdit: boolean) {
    this.show = true
    this.isEdit = isEdit
    this.loadShopById(data.id)

  }

  private async loadShopById(shopId: any) {
    const data = await QueryShopById({ id: shopId })
    this.data = { ...this.data, ...data }
    // 加载绑定商品

    if (this.data.logo) {
      this.data.logoList = this.data.logo.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.logoList = []
    }
   

  }

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    name: [this.requiredRule],
    kfPhone: [this.requiredRule],
    logo: [this.requiredRule],
    shopDesc: [this.requiredRule],
    address: [this.requiredRule],
    shopType: [this.requiredRule],
    companyName: [this.requiredRule],
    creditCode: [this.requiredRule],
    businessLicense: [this.requiredRule],
    openAccountLicenceUrl: [this.requiredRule],
    contactsName: [this.requiredRule],
    contactsPhone: [this.requiredRule, Rules.isMobile],
    contactsEmail: [this.requiredRule, Rules.isEmail],
    contactsLicenceNo: [this.requiredRule],
    legalName: [this.requiredRule],
    legalLicenceNo: [this.requiredRule],
    legalLicenceFrontUrl: [this.requiredRule],
    legalLicenceBackUrl: [this.requiredRule],
    'bankCard.bankType': [this.requiredRule],
    'bankCard.bankCode': [this.requiredRule],
    'bankCard.accountName': [this.requiredRule],
    'bankCard.accountNo': [this.requiredRule],
  }

  public async save() {
    this.buttonLoading = true
    try {

      this.data.logo = this.data.logoList.map((e: any) => e.url).join(',')
    

      const form = this.$refs.form as ElForm
      form.validate(async (valid: boolean) => {
        if (valid) {
          // 获取经纬度
          const location = await TxLocal.getLal(this.data.address)
          // if(!location.success){
          //   this.$message.error("解析地址的经纬度失败，请核对地址填写是否完整")
          //   return
          // }
          this.data.longitude = location.location.lng
          this.data.latitude = location.location.lat

          console.log(this.data)

          let result = {}
          result = await UpdateBaseShop(this.data)
          console.log(result)
          if (result) {
            this.close()
          }

        } else {
          this.$message.error("表单存在错误，不能保存")
          return false
        }

      })
    } finally {
      this.buttonLoading = false
    }
  }
}
